export enum RegFailureReasons {
	passcode = 'invalid-passcode',
	domain = 'invalid-email-domain',
	missingRequired = 'missing-required-field',
	missingPasscodeLists = 'no-matching-passcode-lists',
	notFoundInPasscodeLists = 'not-found-passcode-lists',
	failedRecaptchaV3 = 'failed-recaptcha-v3',
	failedRecaptchaV2 = 'failed-recaptcha-v2',
	registrationClosed = 'registration-closed',
	badWords = 'bad-words-detected',
	deletedRegistration = 'deleted-registration',
	unmatchedPassword = 'unmatched-password',
	noPassword = 'no-password',
	emailAndPasswordNotFound = 'email-and-password-not-found',
	passwordRequirementsNotMet = 'password-requirements-not-met',
	invalidPasswordResetCode = 'invalid-pw-reset-code',
	offline = 'offline',
	connectionFailed = 'connection-failed',
	invalidInputs = 'invalid-inputs',
	serverError = 'Internal server error'
}

// thrown as Errors by the registration service and returned as e.message, so they reach us unmapped
const SSO_ERROR_MESSAGES: string[] = [
	'Error logging in with SSO',
	'SSO registration missing redirect uri',
	'Auth code received, but single sign on is not enabled',
	'No fields were mapped from SSO integration',
	'Auth code received, but cognito app could not be found',
	'Auth code received, but jackson app could not be found',
	'Auth code received, but no oAuth2Integration found'
];

export const isSSOError = (error?: RegFailureReasons | string): boolean =>
	!!error && SSO_ERROR_MESSAGES.includes(error);

// a rejection carrying a reason is a server response; anything else never completed
export const getRegistrationError = (payload: unknown): RegFailureReasons => {
	const raw = (payload as { error?: unknown })?.error;

	if (typeof raw === 'string') {
		try {
			return JSON.parse(raw).error as RegFailureReasons ?? RegFailureReasons.serverError;
		} catch {
			return raw as RegFailureReasons;
		}
	}

	if (payload instanceof Error) {
		return RegFailureReasons.connectionFailed;
	}

	return RegFailureReasons.serverError;
};
